import { addStyle } from 'dom-helper';
import iFrameBuilder from './iframe-builder';
import PathHelper from './path-helper';
import ENV from '../config/env';

import AD_BRICK_VERSION from '../../../gwi-ads/iab_300x250/src/config/version';

export default class Iab300x250IframeBuilder extends iFrameBuilder {
  static getFilePath() {
    const brickPath = ENV.ad300BrickPath;
    return `${PathHelper.getBrickPath(brickPath, AD_BRICK_VERSION)}/${ENV.brickIndexFileName}`;
  }

  static styleHolder(holder) {
    addStyle(holder, {
      height: '250px',
      width: '300px',
    });

    return holder;
  }
}



// WEBPACK FOOTER //
// ./src/utils/ad-300-iframe-builder.js